import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import qs from 'qs';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Cookies from 'js-cookie';
import _ from 'lodash';

import NewNavButtonGroup from './NewNavButtonGroup';
import ScrollLock from 'react-scrolllock';
import NewCourseSectionList from './NewCourseSectionList';
import NewAccessibility from './NewAccessibility';
import NewLegal from './NewLegal';
import NewCustomer from './NewCustomer';
import NewWheelchair from './NewWheelchair';
import NewSafety from './NewSafety';
import NewExam from './NewExam';
import Loading from '../shared/Loading';
// import './index.css';
import './newcourse.css';

// import Header from '../NewProfile/Header';
import Header from './NewCourseHeader';
import SideBarContent from '../SideBar/SideBarContent';

class NewCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0
    };
  }

  componentDidMount() {
    const { page = 0 } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });
    this.changePage(Number(page));
  }

  // componentDidMount() {
  //   const { page = 0 } = qs.parse(this.props.location.search, {
  //     ignoreQueryPrefix: true
  //   });
  //   this.changePage(Number(page));
  // }

  // changePage = (page, passed) =>
  //   this.setState({ page }, () => {
  //     const { history } = this.props;
  //     window.scrollTo(0, 0);
  //     // if a user tries to navigate to page 7 without passing they will be redirected
  //     if (page === 7 && !passed) {
  //       history.push('newcourse');
  //     } else if (page > 0 && page <= 6) {
  //       history.push(`newcourse?page=${page}`);
  //     } else {
  //       history.push('newcourse');
  //     }
  //   });

  handleCookies = page => {
    if (!Cookies.getJSON('Course')) {
      const course = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false
      };
      course[page] = true;
      Cookies.set('Course', course, { expires: 14 });
    } else {
      const course = _.clone(Cookies.getJSON('Course'));
      course[page] = true;
      Cookies.set('Course', course, { expires: 14 });
    }
  };

  scrollToTop = () => {
    const course = document.getElementById('new-course');
    if (course) {
      course.scrollTop = 0;
    }
  };

  changePage = (page, passed) =>
    this.setState({ page }, () => {
      const { history } = this.props;
      this.scrollToTop();
      // bypass for app development shortcut
      if (/coursehtml/.test(window.location.href)) {
        if (page > 0 && page <= 6) {
          history.push(`coursehtml?page=${page}`);
        } else {
          history.push('coursehtml');
        }
      } else {
        // if a user tries to navigate to page 7 without passing they will be redirected
        if (page > 0 && page <= 6) {
          history.push(`course?page=${page}`);
        } else {
          history.push('course');
        }
      }
      // handle course page cookies
      page === 0 || page === 6 ? null : this.handleCookies(page);
      // Cookies.set(page, true, { expires: 14 });
    });

  handleGoBack = () => {
    this.setState({ page: 0 });
  };

  handleRender = ({ passed, ...props }) => {
    const { page = 0 } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });

    // console.log('page change', this.state.progress);
    switch (Number(page)) {
      case 1:
        return (
          <NewAccessibility
            changePage={this.changePage}
            page={1}
            passed={passed}
          />
        );
      case 2:
        return (
          <NewLegal
            changePage={this.changePage}
            page={2}
            passed={passed}
          />
        );
      case 3:
        return (
          <NewCustomer
            changePage={this.changePage}
            page={3}
            passed={passed}
          />
        );
      case 4:
        return (
          <NewWheelchair
            changePage={this.changePage}
            page={4}
            passed={passed}
          />
        );
      case 5:
        return (
          <NewSafety
            changePage={this.changePage}
            page={5}
            passed={passed}
          />
        );
      case 6:
        return (
          <NewExam
            changePage={this.changePage}
            page={6}
            {...props}
            {...this.props}
            passed={passed}
          />
        );
      default:
        return (
          <NewCourseSectionList
            changePage={this.changePage}
            {...props}
            passed={passed}
          />
        );
    }
  };
  render() {
    const { history } = this.props;
    const { page } = this.state;
    return (
      <Query
        query={gql`
          {
            currentUser {
              id
              plusTestPassed
            }
          }
        `}>
        {({ loading, error, data, refetch }) => {
          if (loading) return <Loading />;
          if (error) return <Redirect to="/404" />;
          return (
            <div className="container new-course">
              {/coursehtml/.test(window.location.href) ? null : (
                <Header
                  persistentTitle
                  title="Autzu PLUS Course"
                  back
                  onClick={() => {
                    if (page === 0) {
                      history.goBack();
                    } else {
                      this.handleGoBack();
                      history.push('course');
                    }
                  }}
                  page={page}
                />
              )}
              {/* <div>new course</div> */}
              <div className="new-course__body__footer--mobile">
                <NewNavButtonGroup
                  changePage={this.changePage}
                  page={page}
                  passed={data.currentUser.plusTestPassed}
                  disabled={!data.currentUser.plusTestPassed}
                />
              </div>
              <ScrollLock>
                <div className="new-course__container" id="new-course">
                  <div className="new-course__sidebar">
                    <SideBarContent
                      status={this.props.status}
                      signedIn={this.props.loggedIn}
                    />
                  </div>
                  <div
                    className="new-course__body"
                    style={
                      /coursehtml/.test(window.location.href)
                        ? { marginTop: '0' }
                        : null
                    }>
                    <this.handleRender
                      passed={data.currentUser.plusTestPassed}
                      loading={loading}
                      refetch={refetch}
                    />
                  </div>
                </div>
              </ScrollLock>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(NewCourse);



// WEBPACK FOOTER //
// ./src/components/NewCourse/index.js